import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-forest text-ember border-forest-line' : 'bg-white text-pine border-paper-dark';
  const label = tone === 'dark' ? 'text-paper/65' : 'text-pine-muted';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-73" data-mp="3259gwyq093sv">
      {units.map(unit => <div key={unit.label} className={`rounded-xl border text-center tabular-nums ${box} ${isLarge ? 'min-w-[74px] px-4 py-3 sm:min-w-[92px] sm:px-6 sm:py-4' : 'min-w-[58px] px-3 py-2'}`} data-id="element-74" data-mp="15b6aeetemhws">
          <div className={`font-display leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-75" data-mp="szzcd8s3r2iz">
            {unit.value}
          </div>
          <div className={`mt-1 font-bold uppercase tracking-widest ${label} ${isLarge ? 'text-[10px]' : 'text-[9px]'}`} data-id="element-76" data-mp="12t7rqgggx49c">
            {unit.label}
          </div>
        </div>)}
    </div>;
}